
<template>
  <svg data-v-62c93367="" xmlns="http://www.w3.org/2000/svg" width="25px" height="25px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="cursor-pointer lab-text-steel feather feather-arrow-right"><line data-v-62c93367="" x1="5" y1="12" x2="19" y2="12"></line><polyline data-v-62c93367="" points="12 5 19 12 12 19"></polyline></svg>
</template>
    
  <script>
  export default {
    components: {
    },
    props: {
    },
    data() {
      return {
      }
    },
  }
  </script>
  
  <style lang="scss" scoped>
  svg {
    height: 18px;
  }  
  </style>
    
      